var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25143_18598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.75H5V7.5H2.5V1.25H8.75V3.75ZM27.5 7.5V1.25H21.25V3.75H25V7.5H27.5ZM8.75 26.25H5V22.5H2.5V28.75H8.75V26.25ZM25 22.5V26.25H21.25V28.75H27.5V22.5H25ZM23.75 22.5C23.75 23.875 22.625 25 21.25 25H8.75C7.375 25 6.25 23.875 6.25 22.5V7.5C6.25 6.125 7.375 5 8.75 5H21.25C22.625 5 23.75 6.125 23.75 7.5V22.5ZM18.75 10H11.25V12.5H18.75V10ZM18.75 13.75H11.25V16.25H18.75V13.75ZM18.75 17.5H11.25V20H18.75V17.5Z",
    fill: "#585C91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25143_18598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.1f346b1a.svg";
export { ForwardRef as ReactComponent };